import styled from 'styled-components'

export const ContainerSpin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
`
